// extracted by mini-css-extract-plugin
export default {"formCardContainer":"kyc-kyc-page_formCardContainer","buttonsContainer":"kyc-kyc-page_buttonsContainer","goBackButton":"kyc-kyc-page_goBackButton"};